export default __webpack_public_path__ + "static/media/4-2_image26@2x.6c483c66.png";